export const specialBotWinTexts = [
    "Te hice de goma",
    "Aprende'a jugar",
    "Ja-ja !!",
    "Te gaste' !!",
    "Adios...",
    "Adios!!",
    "Chau pinela...!",
    "Calenchu ... !!",
    "Disculpe, jefe!",
    "Ole, olita...!!",
    "Te hice caucho!",
    "Te hice pomada!",
];
export const specialHumanWinTexts = [
    "No la puedo...",
    "No, no ligue'!",
    "Che, que'liga!",
    "Me quede corto",
    "Me pasaste !!",
    "Como robaste !",
];